import React from 'react'

interface SkeletonProps {
  className?: string
  color?: string
}

const Skeleton: React.FC<SkeletonProps> = ({ className = '', color = 'bg-[#ececec]' }) => (
  <div className={`animate-pulse ${color} ${className}`} aria-hidden="true" />
)

export default Skeleton
